module.exports = "<p>{{firstOrSecond|e}}</p>\n";
